import { CallState, LoadingState } from '@lcs/shared/api';
import { createReducer, on } from '@ngrx/store';
import { onReset } from 'src/app/authentication/reset-reducer';
import { PhoneNumberDetailView } from '../models/phone-number-detail-view.model';
import { GetPhoneNumberDetail_phoneNumber } from '../queries/generated/GetPhoneNumberDetail';
import * as PhoneNumberDetailActions from './phone-number-detail.actions';

export const phoneNumberDetailFeatureKey = 'phoneNumberDetail';

export interface State {
   phoneNumber: PhoneNumberDetailView | null;
   callState: CallState;
}

export const initialState: State = {
   callState: LoadingState.Init,
   phoneNumber: null,
};

export const reducer = createReducer(
   initialState,
   onReset(initialState),
   on(PhoneNumberDetailActions.phoneNumberDetailLoad, PhoneNumberDetailActions.phoneNumberDetailCancel, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
         phoneNumber: null,
      };
   }),
   on(
      PhoneNumberDetailActions.loadPhoneNumberDetailSuccess,
      PhoneNumberDetailActions.loadSystemPhoneNumberDetailSuccess,
      (state, action) => {
         const phoneNumber: GetPhoneNumberDetail_phoneNumber = action.data;
         return {
            ...state,
            callState: LoadingState.Loaded,
            phoneNumber: {
               ...phoneNumber,
               phonesUsingForCallerId: phoneNumber.phonesUsingForCallerIdConnection.items.map((item) => {
                  return {
                     extensionId: item.extension.extensionId,
                     number: item.extension.number,
                     name: item.extension.name,
                     extensionPhoneId: item.extensionPhoneId,
                     displayName: item.displayName,
                     defaultPhoneNumberId: item.defaultPhoneNumberId,
                  };
               }),
               faxesUsingForCallerId: phoneNumber.faxesUsingForCallerIdConnection.items.map((item) => {
                  return {
                     extensionId: item.extension.extensionId,
                     number: item.extension.number,
                     name: item.extension.name,
                     extensionFaxId: item.extensionFaxId,
                     defaultPhoneNumberId: item.defaultPhoneNumberId,
                  };
               }),
               createUser: phoneNumber.createUser as string | null,
               updateUser: phoneNumber.updateUser as string | null,
            },
         };
      }
   ),
   on(PhoneNumberDetailActions.loadPhoneNumberDetailFailure, (state, action) => {
      return {
         ...state,
         callState: action,
      };
   }),
   on(PhoneNumberDetailActions.navigate, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(PhoneNumberDetailActions.savePhoneNumberDetail, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(
      PhoneNumberDetailActions.savePhoneNumberDetailFailure,
      PhoneNumberDetailActions.phoneNumberDetailAccessDenied,
      (state) => {
         return {
            ...state,
            callState: LoadingState.Loaded,
         };
      }
   )
);
